import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import { useMobileMediaQuery } from "hooks";
import { DonutChartLoader } from "Components/DonutChart/Loader";
import { InfoBarsLoader } from "Components/InfoBars/Loader";

export const Loader: React.FC = () => {
  const isMobile = useMobileMediaQuery();

  return (
    <Container>
      <Skeleton height={25} width={250} />
      <ChartContainer>
        <TotalContainer>
          <Skeleton height={20} width={95} />
          <Skeleton height={55} width={75} />
        </TotalContainer>
        <DonutChartLoader withVerticalLayout={isMobile} />
      </ChartContainer>
      <Categories>
        {Array.from({ length: isMobile ? 1 : 2 }, (_, i) => i).map((idx) => (
          <Category key={`clicks-loader-${idx}`}>
            <Skeleton height={20} width={150} />
            <InfoBarsLoader />
          </Category>
        ))}
      </Categories>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 5px;
`;

const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 35px;
  margin: 60px 0 45px;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    margin: 40px 0 40px;
    gap: 25px;
  }
`;

const TotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const Categories = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 80px;
  width: 100%;
`;

const Category = styled.div`
  flex: 1;
`;
